import dot from 'dot/doT';
import BaseFilter from './baseFilter';
import $ from 'jquery';
import template from '../../views/filterblocks/checkboxes.dot';
const templateFunction = dot.template(template);

const CLASSES = {
    entered: 'input--entered',
};

export default class CheckboxInput extends BaseFilter {

    constructor(parentEl, options = {}) {
        super(options);

        this.parentEl = parentEl;
        this.options = $.extend({}, options);
        this._drawCheckboxes();
    }
    unselect($element) {
        $element.prop('checked', false);
    }
    _drawCheckboxes() {
        const renderdTemplate = $(templateFunction(this.options));
        this.inputEl = renderdTemplate.find('input');

        this.parentEl.append(renderdTemplate);
        this.el = renderdTemplate;
        this.el.change((function (e) {
            this._onChangeEvent(e.target);
        }).bind(this));
        this.setupCloseApplyButtons();
    }
    _onChangeEvent(element) {
        const $el = $(element);
        this._markElementSelected($el);
        const val = $el.val();
        const label = $el.parents('.input').find('.input__label').text();
        const selectedItem = {
            label: label,
            value: val,
            selected: $el.is(':checked'),
            inputEl: $el,
            checkbox: this

        };
        if (this.options.onChangeEvent) {
            this.options.onChangeEvent(selectedItem);
        }
    }
    _markElementSelected(element) {
        element.parents('.input').addClass(CLASSES.entered);
    }

    getInputElFromValue(value) {
        return this.inputEl.filter(function (i, el) { return el.value === value;  });
    }


}
